<template>
  <div class="alert-select">
    <div class="select-box">
      <div class="select-header">
        <label>{{ label }}</label>
        <div class="select-actions">
          <span
            v-if="!this.async"
            class="controls"
            @click="toggleAll">
            <span v-if="selected.length === items.length">Deselect All</span>
            <span v-else>Select All</span>
          </span> <span v-if="!this.async">|</span>
          <span
            class="controls"
            @click="clear">Clear</span>
        </div>
      </div>
      <div class="select-body">
        <div class="select-search">
          <v-text-field
            v-model="searchField"
            class=""
            placeholder="Search..."
            hide-details
            @input="search"/>
        </div>
        <div class="select-items">
          <div
            v-if="loading"
            class="flex-center pa-4">
            <v-progress-circular
              size="30"
              indeterminate/>
          </div>
          <div
            v-for="(item, key) in filtered"
            :key="key"
            class="select-item">
            <v-checkbox
              v-model="selected"
              :value="item.value"
              :label="item.text"
              hide-details
              @change="(val) => selectItem(val, item)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
import axios from 'axios'
import _ from 'lodash'

const CancelToken = axios.CancelToken

export default {
  props: {
    items: Array,
    label: String,
    value: Array,
    async: Boolean,
    uri: String
  },
  data () {
    return {
      checkbox: null,
      selected: [],
      filtered: [],
      firstRun: true,
      cachedItems: [],
      searchField: null,
      loading: false,
      axiosSource: null
    }
  },
  watch: {
    items: {
      deep: true,
      immediate: true,
      handler (val) {
        this.cachedItems = val
        this.filtered = val.slice(0, 50)
      }
    },
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        this.selected = val
        if (!this.firstRun) return
        // move the selected to the top of the items
        const filterSelected = this.items.filter(item => {
          return val.includes(item.value)
        })
        const remainingItems = this.items.filter(item => {
          return !val.includes(item.value)
        })
        const rearrangedItems = filterSelected.concat(remainingItems)
        this.$nextTick(() => {
          this.cachedItems = rearrangedItems
          this.filtered = rearrangedItems.slice(0, 50)
          this.firstRun = false
        })
      }
    }
  },
  methods: {
    toggleAll () {
      if (this.selected.length) {
        this.selected = []
      } else {
        this.selected = this.items.map(val => val.value)
      }
      this.$emit('input', this.selected)
    },
    selectItem (val, item) {
    //   if (val) {
    //     this.selected.push(item.value)
    //   } else {
    //     var index = this.selected.indexOf(item.value)
    //     this.selected.splice(index, 1)
    //   }
      this.$emit('input', this.selected)
    },
    isSelected (item) {
      return this.selected.indexOf(item.value) >= 0
    },
    asyncSearch: _.debounce(async function () {
      if (this.axiosSource) {
        this.axiosSource.cancel()
      }
      const source = CancelToken.source()
      this.loading = true
      this.filtered = []
      const { data } = await axios
        .get(`${this.uri}?search=${this.searchField}`, {
          cancelToken: source.token
        })
      this.axiosSource = source
      this.filtered = data.map(item => {
        return {
          text: item.pointofcontact,
          value: item.pointofcontactemail || item.pointofcontactphonenum || item.pointofcontact
        }
      }).filter(item => {
        return item.text.length && item.value.length
      })

      this.loading = false
    }, 400),
    async search (val) {
      if (this.async) {
        return this.asyncSearch()
      }
      const fuse = new Fuse(this.cachedItems, {
        threshold: 0.3,
        keys: ['text']
      })

      if (!val.length) {
        this.filtered = this.cachedItems.slice(0, 50)
        return
      }

      const result = fuse.search(val)
      this.filtered = result.slice(0, 50)
    },
    clear () {
      this.searchField = null
      this.selected = []
      this.filtered = this.cachedItems.slice(0, 50)
    }
  }
}
</script>

<style
  lang="scss"
  scoped>
  .alert-select {
    width: 100%;
    background: #fff;

    .select-box {
      border: 1.5px solid #d2d2d2;
      .select-header {
        display: flex;
        background: #d2d2d2;
        width: 100%;
        padding: 10px;

        label {
          flex: 1;
          font-weight: bold;
          font-size: 16px;
        }

       .select-actions {
          align-self: center;
          float: right;
          .controls {
            text-decoration: underline;
            cursor: pointer;
          }
       }
      }
      .select-body {
        .v-input--selection-controls {
          padding: 0px !important;
          margin-top: 0px !important;
        }
        .select-search {
          padding: 8px 16px;
          .input-group {
            padding: 0px;
          }
        }
        .select-items {
          height: 220px;
          overflow: scroll;
          .select-item {
            padding: 4px 10px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// bidAlertSelect.vue?7c75807d